import StickySidebar from "../stickySidebar.js";
import ArticleNavigation from "../articleNavigation.js";
import { changeMediaListener } from "../changeMediaListener.js";
import { initDesktopHeaderSearch } from "../search";
import { initHamburgerMenu } from "../hamburger";
import { initHamburgerAccordion } from "../hamburger";
import { initCookiesConsent } from "../cookies-consent";
import { initAccordion } from "../../utils-shared/accordion.js";
import { initPopup } from "../../utils-shared/popup.js";

window.addEventListener("load", function () {
  changeMedia();
  initDesktopHeaderSearch();
  initHamburgerMenu();
  initHamburgerAccordion();
  initCookiesConsent();
  initPopup();
  initAccordion();
});

function changeMedia() {
  let sticky = null;
  let articleNavigation = null;

  const initNavigation = () => {
    if (!articleNavigation) {
      articleNavigation = new ArticleNavigation({});
    }
  };

  const phoneAndTabletHandler = () => {
    if (sticky) {
      sticky.destroy();
      sticky = null;
    }

    initNavigation();
    articleNavigation.destroyDesktopListeners();
  };

  const desktopHandler = () => {
    if (!sticky) sticky = new StickySidebar(".fixed-panel-inner");

    initNavigation();
    articleNavigation.initDesktopListeners();
  };

  changeMediaListener({
    phoneAndTabletHandler,
    desktopHandler,
  });
}
